import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.opsgenie',
		defaultMessage: 'Opsgenie',
		description: 'The link label for Opsgenie',
	},
});
